<div class="modal-wrapper">
  <div class="overlay" *ngIf="blockui">
    <app-spinner></app-spinner>
  </div>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      <span *ngIf="!isExportFromSearchstrategy">Export - Criteria Selection for Unadjusted Data </span>
      <span *ngIf="isExportFromSearchstrategy">Export - Criteria Selection </span>
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body eliminationMatrixDisplay fixed-body">
    <div class="row" *ngIf="message?.length > 0">
      <div class="col-12">
        <ngb-alert (close)="message = ''" [type]="type">{{ message }}</ngb-alert>
      </div>
    </div>

    <div class="row" *ngIf="!exportAll">
      <div class="col-12">
        <div class="exported">
          <i class="material-icons"> info </i> <label>This exported file must match exactly when importing back into this tool.</label>
        </div>
      </div>
    </div>
    <div class="row mt-5" [ngClass]="{ 'mt-5': !exportAll }">
      <div class="col-12">
        <label>Fiscal Year Selection: </label>
        <div class="form-group">
          <div class="usrDefined">
            <div class="study-rd-btn ms-1">
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  id="studyFiscalYr"
                  name="studyFiscalYr"
                  [(ngModel)]="isStudyFiscalYear"
                  [value]="true"
                  class="custom-control-input"
                />
                <label class="custom-control-label form-check-label" for="studyFiscalYr">Study Fiscal Year</label>
              </div>

              <div class="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  id="customFiscalYr"
                  name="customFiscalYr"
                  [value]="false"
                  [(ngModel)]="isStudyFiscalYear"
                  class="custom-control-input"
                  (change)="isStudyFiscalYear = false"
                />
                <label class="custom-control-label form-check-label" for="customFiscalYr">Custom Fiscal Year</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="!isStudyFiscalYear">
      <div class="col-6">
        <div class="form-group" [ngClass]="{ 'has-error': ShowValidationMessage(startFY) || null }">
          <span class="ey-float-label">
            <select
              class="form-control form-select"
              id="startFY"
              name="startFY"
              [(ngModel)]="financialAdjFilter.startFY"
              required
              #startFY="ngModel"
              appLabelFloat
            >
              <option *ngIf="!financialAdjFilter.startFY" [value]="undefined" disabled selected></option>
              <option *ngFor="let yr of years" [ngValue]="yr">{{ yr }}</option>
            </select>
            <label>Period Beginning</label>
          </span>
          <span class="help-block">
            <span *ngIf="ShowValidationMessage(startFY) && startFY.errors.required"> Please select a period of beginning </span>
          </span>
        </div>
      </div>

      <div class="col-6">
        <div class="form-group" [ngClass]="{ 'has-error': ShowValidationMessage(endFY) || null }">
          <span class="ey-float-label">
            <select
              class="form-control form-select"
              id="endFY"
              name="endFY"
              [(ngModel)]="financialAdjFilter.endFY"
              required
              #endFY="ngModel"
              appLabelFloat
            >
              <option *ngIf="!financialAdjFilter.endFY" [value]="undefined" disabled selected></option>
              <option *ngFor="let yr of years" [ngValue]="yr">{{ yr }}</option>
            </select>
            <label>Period Ending</label>
          </span>
          <span class="help-block" *ngIf="ShowValidationMessage(endFY) && endFY.errors.required"> Please select a period of ending </span>
          <span class="help-block" *ngIf="checkPeriodEnding()"> Period ending should be greater than period of beginning. </span>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="!isExportFromSearchstrategy">
      <div class="col-12">
        <label>PLI ratio(s): </label>
        <div class="form-group ey-add-filter-body" [ngClass]="{ 'has-error': ShowValidationMessageForRatio() }">
          <div class="usrDefined">
            <p-table
              [value]="financialRatios"
              selectionMode="multiple"
              [(selection)]="selectedFinancialRatios"
              [scrollable]="true"
              (onRowSelect)="selectFinancialItem($event)"
              (onHeaderCheckboxToggle)="selectFinancialItem($event)"
              scrollHeight="163px"
              class="table-control"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th style="width: 3em"><p-tableHeaderCheckbox></p-tableHeaderCheckbox>Select All</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData>
                <tr>
                  <td><p-tableCheckbox [value]="rowData"></p-tableCheckbox>{{ rowData.label }}</td>
                </tr>
              </ng-template>
            </p-table>
            <span class="help-block" *ngIf="ShowValidationMessageForRatio()"> Please select a PLI ratio(s) </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label>Financial Items: </label>
        <div class="form-group">
          <div class="p-checkbox-grp usrDefined">
            <p-tree
              id="financialItem"
              name="financialItem"
              [(value)]="financialItems"
              [(selection)]="selectedFinancialItems"
              [loading]="loading"
              selectionMode="checkbox"
              (onNodeSelect)="nodeSelect($event)"
              [propagateSelectionUp]="true"
              [propagateSelectionDown]="true"
              (onNodeUnselect)="nodeUnselect($event)"
            >
            </p-tree>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="close()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="exportToExcel_financial()">Export</button>
  </div>
</div>
